import React, { createContext, useReducer } from 'react';

import type { CvtDiagnosticUploadsActionDispatcher, CvtDiagnosticUploadsState } from './qmr-cvt-diagnostic.state';

import { cvtDiagnosticUploadsReducer, initialState } from './qmr-cvt-diagnostic.state';

export const CvtDiagnosticUploadsStateContext = createContext<CvtDiagnosticUploadsState | undefined>(undefined);
export const CvtDiagnosticUploadsDispatchContext = createContext<CvtDiagnosticUploadsActionDispatcher | undefined>(
    undefined
);

export function CvtDiagnosticUploadsProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(cvtDiagnosticUploadsReducer, initialState);

    return (
        <CvtDiagnosticUploadsStateContext.Provider value={state}>
            <CvtDiagnosticUploadsDispatchContext.Provider value={dispatch}>
                {children}
            </CvtDiagnosticUploadsDispatchContext.Provider>
        </CvtDiagnosticUploadsStateContext.Provider>
    );
}
